<template>
  <div class="box" @click="showGuide = false">
    <div
      :class="{ details: isHeytapPhone }"
      v-if="videoData.videos"
      @touchstart="addListScroll"
      @touchend="removerListScroll"
    >
      <div class="content">
        <div class="video-box">
          <video
            ref="video"
            x5-playsinline
            x-webkit-airplay="allow"
            webkit-playsinline="true"
            playsinline="true"
            disable-video-auto-fullscreen="true"
            video-no-fixed-top="true"
            preload="auto"
            autoplay
            v-show="videoShow"
            controls
            controlslist="nodownload"
            @play="onPlay"
            @canplay="onCanPlay"
            @playing="onPlaying"
            @ended="onEnded"
            @pause="onPause"
            :poster="videoData.videos[0].image"
          >
            <source
              :src="videoData.videos[0].url"
              type="video/mp4"
              referrer="no-referrer"
            />
            您的浏览器不支持该视频格式。
          </video>

          <div class="video" v-if="!videoShow" @click="playVideo">
            <div
              class="video-img"
              :style="{
                backgroundImage: 'url(' + videoData.videos[0].image + ')',
              }"
            />

            <div class="video-play" v-if="!isPlayEnd" />
            <!-- <div class="play-icon-load" v-if="isPlayLoad"></div> -->
            <div class="play-end" v-else>
              <div
                class="btn"
                v-if="isHeytapPhone"
                @click.stop="callMarketByPkg(1)"
              >
                {{ isApkInstall() ? '打开' : '下载' }}APP查看更多
              </div>
              <div class="anew-play" @click.stop="anewPlay" />
            </div>

            <div
              class="bottom-title"
              @click.stop="callMarketByPkg(2)"
              v-if="isHeytapPhone"
            >
              使用短视频客户端，更清晰更流畅
            </div>
          </div>
        </div>
        <div class="video-title">
          <span>{{ videoData.title }}</span>
          <div class="conent-text">
            <div class="video-count">
              <span
                class="icon"
                :style="{
                  backgroundImage: 'url(' + videoData.medium.avatar + ')',
                }"
              />
              {{ videoData.medium.name }} {{ viewCount(videoData) }}万次观看
            </div>
          </div>
        </div>
      </div>

      <List
        v-if="!videoListLoading && isHeytapPhone"
        @callMarketByPkg="callMarketByPkg(3)"
        :video-list="videoList"
      />
      <div v-if="videoListLoading" class="loading no-list">
        <div class="icon" v-if="isHeytapPhone" />
      </div>

      <div class="bottom-btn" v-if="isHeytapPhone" @click="callMarketByPkg(4)">
        <div class="btn-row">
          <span class="text">使用官方短视频APP，新鲜看不停</span>
          <span class="btn">立即加入</span>
        </div>
      </div>
      <div @click="dadian">
        <GuideBanner
          class="top-banner"
          v-if="isHeytapPhone"
          @show="_showGuide"
          :is-show-tip="isShowTip"
          ref="guideBanner"
        />
      </div>
      <div class="open-guide" @click.stop v-if="showGuide">
        选择在浏览器中打开，用短视频APP观看更多精彩
      </div>
    </div>
    <div class="loading" v-else>
      <div class="icon" />
    </div>
  </div>
</template>

<script>
import yoliBanner from '@oppobrowser/lib-browser-yoliBanner';
import GuideBanner from '../components/guide_banner';
import List from '../components/video-list';
import commen from '../components/commen';
import { fetchVideoInfo, fetchRelateVideoList } from '../common/js/fetch.js';

const { isApkInstall } = yoliBanner;

export default {
  name: 'VideoDetails',

  data() {
    return {
      showGuide: false,
      videoShow: false,
      isPlayEnd: false,
      videoData: {},
      videoList: [],
      videoListLoading: false,
      count: 10,
      videoOffsetTop: 0,
      videoClientHeight: 0,
      dadian_time: 0,
      firstPlay: true,
    };
  },

  computed: {},

  mixins: [commen],

  created() {
    this.dadian_time = Date.now();
    this.getVideoInfo().then(() => {
      if (this.isHeytapPhone) {
        this.getRelateVideoList();
      }
    });
    window.oa('send', {
      hitType: 'pageview',
      page: 'details-show+/details',
    });
    // window.videoDetail = this // for test
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.setScroll);
  },

  components: {
    GuideBanner,
    List,
  },

  methods: {
    isApkInstall,
    viewCount(videoData) {
      const count =
        videoData.videos[0].viewCnt < 10000
          ? 1
          : Math.ceil(videoData.videos[0].viewCnt / 10000);
      return count;
    },
    setStoreState(state) {
      this.$store.commit('detail/SET_STATE', state);
    },
    onPause() {
      console.log('onPause');
      if (this.$refs.video) {
        const time = this.$refs.video.currentTime;
        if (!time || time < 1) {
          this.videoShow = false;
        }
        // alert('onPuase currentTime is' + this.$refs.video.currentTime )
      }
    },
    async getVideoInfo() {
      const query = this.$route.query;
      const params = {
        docid: query.id,
        source: query.source,
      };
      return fetchVideoInfo(params).then((data) => {
        // console.log(data)
        this.videoData = data;
        console.log(this.videoData);
        // this.videoShow = true
        let options = {
          title: '分享给@你一个精彩视频',
          desc: this.videoData.title,
          imgUrl: this.videoData.videos[0].image,
          link: window.location.href,
        };
        window.shareConfig(options);
        window.oa('send', {
          hitType: 'event',
          eventCategory: 'time',
          eventAction: 'time',
          eventLabel: '/details',
          eventValue: Date.now() - this.dadian_time,
        });
      });
    },
    async getRelateVideoList() {
      const query = this.$route.query;
      const params = {
        docid: query.id,
        source: query.source,
        mediaNo: query.mediaNo,
      };
      this.videoListLoading = true;
      return fetchRelateVideoList(params).then((data) => {
        console.log(data);

        let result = [];
        data.items.forEach((item) => {
          data.articles.forEach((article) => {
            if (item.id === article.id && item.map === 'articles') {
              result.push(article);
            }
          });
        });
        this.videoList = result || [];
        this.videoListLoading = false;
      });
    },
    dadian() {
      window.oa('send', {
        hitType: 'event',
        eventCategory: 'top_btn',
        eventAction: 'click',
        eventLabel: '/details',
        eventValue: '',
      });
    },
    onPlaying() {
      console.log('playing');
    },
    onCanPlay() {
      console.log('onCanPlay');
      this.videoShow = true;
      this.isPlayEnd = false;
    },
    onPlay() {
      console.log('onPlay');
      if (!this.firstPlay) {
        this.videoShow = true;
      }
      this.firstPlay = false;
    },
    onEnded() {
      console.log('onEnded');
      this.isPlayEnd = true;
      this.videoShow = false;
      this.$refs.video.currentTime = 0;
      window.oa('send', {
        hitType: 'event',
        eventCategory: 'video_end',
        eventAction: 'paly',
        eventLabel: '/details',
        eventValue: this.videoData.id,
      });
    },

    anewPlay() {
      this.videoShow = true;
      this.$refs.video.currentTime = 0;
      this.$refs.video.play();
      window.oa('send', {
        hitType: 'event',
        eventCategory: 'video_end_play_btn',
        eventAction: 'click',
        eventLabel: '/details',
        eventValue: '',
      });
    },
    addListScroll() {
      if (this.$refs.video && !this.$refs.video.paused) {
        window.addEventListener('scroll', this.setScroll);
      }
    },

    removerListScroll() {
      window.removeEventListener('scroll', this.setScroll);
    },

    playVideo() {
      if (this.isPlayEnd) {
        return;
      }
      // console.log(this.$refs.video)

      this.videoShow = true;

      this.$refs.video.play();
      window.oa('send', {
        hitType: 'event',
        eventCategory: 'video',
        eventAction: 'click',
        eventLabel: '/details',
        eventValue: this.videoData.id,
      });
      // window.addEventListener("scroll", this.setScroll);
      this.videoOffsetTop = this.$refs.video.parentNode.offsetTop;
      this.videoClientHeight = this.$refs.video.parentNode.clientHeight;
    },

    _showGuide() {
      this.showGuide = !this.showGuide;
      if (this.showGuide) {
        this.$refs.video.pause();
        this.videoShow = false;
      }
    },

    callMarketByPkg(index) {
      this.$refs.guideBanner.callMarketByPkg();
      this.$refs.video.pause();
      this.videoShow = false;
      switch (index) {
        case 1:
          window.oa('send', {
            hitType: 'event',
            eventCategory: 'video_end_btn',
            eventAction: 'click',
            eventLabel: '/details',
            eventValue: '',
          });
          break;
        case 2:
          window.oa('send', {
            hitType: 'event',
            eventCategory: 'video_bottom_btn',
            eventAction: 'click',
            eventLabel: '/details',
            eventValue: '',
          });
          break;
        case 3:
          window.oa('send', {
            hitType: 'event',
            eventCategory: 'list_video_btn',
            eventAction: 'click',
            eventLabel: '/details',
            eventValue: '',
          });
          break;
        case 4:
          window.oa('send', {
            hitType: 'event',
            eventCategory: 'bottom_btn',
            eventAction: 'click',
            eventLabel: '/details',
            eventValue: '',
          });
          break;
      }
    },

    setScroll() {
      let scroll, Height, scrollHeight;
      if (document.body.scrollTop) {
        scroll = document.body.scrollTop;
      } else {
        scroll = document.documentElement.scrollTop;
      }
      // console.log(scroll,this.videoOffsetTop,this.videoClientHeight)
      if (scroll > this.videoOffsetTop + this.videoClientHeight) {
        if (!this.$refs.video.paused) {
          // this.$refs.video.pause()
        }
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.top-banner {
  top: 0;
}
.details {
  padding-top: px2rem(178);
}
.box {
  height: 100%;
  width: 100%;
}
.loading {
  height: 100%;
  width: 100%;
  position: relative;
  .icon {
    background: url('../common/img/loading.gif') no-repeat 0 0 / px2rem(80)
      px2rem(80);
    width: px2rem(80);
    height: px2rem(80);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.no-list {
  height: px2rem(750);
}
.content {
  border-bottom: px2rem(1) solid #dedede;
}
.video {
  position: absolute;
  width: 100%;
  min-height: px2rem(600);
  top: 0;
  left: 0;
}
.video-box {
  width: 100%;
  min-height: px2rem(600);
  position: relative;
}
.video-img {
  width: 100%;
  min-height: px2rem(600);
  position: relative;
  overflow: hidden;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}
.video-play {
  background: url('../common/img/Group.png') no-repeat 0 0 / px2rem(112)
    px2rem(112);
  width: px2rem(112);
  height: px2rem(112);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
}
.play-end {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  .btn {
    width: px2rem(500);
    height: px2rem(120);
    color: #fff;
    background: #fb3458;
    border-radius: px2rem(30);
    text-align: center;
    line-height: px2rem(122);
    font-weight: 700;
    font-size: px2rem(44);
    margin-right: px2rem(28);
  }
  .anew-play {
    background: url('../common/img/anew-play.png') no-repeat 0 0 / px2rem(120)
      px2rem(120);
    width: px2rem(120);
    height: px2rem(120);
  }
}
.play-icon-load {
  background: url('../common/img/loading.gif') no-repeat 0 0 / px2rem(80)
    px2rem(80);
  width: px2rem(80);
  height: px2rem(80);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.video-title {
  font-size: px2rem(48);
  color: #000;
  margin: px2rem(40) px2rem(54);
  position: relative;
  letter-spacing: 0.16px;
  // top: px2rem(612);
  // left: 0;
  font-weight: 500;
  span {
    font-weight: 700;
  }
  .conent-text {
    margin-top: px2rem(8);
  }
}
.video-count {
  font-size: px2rem(33);
  color: #b2b2b2;
  padding-bottom: px2rem(10);
  padding-top: px2rem(8);
  display: flex;
  align-items: center;
  .icon {
    width: px2rem(44);
    height: px2rem(44);
    display: inline-block;
    margin-right: px2rem(20);
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 50%;
  }
}
.bottom-title {
  position: absolute;
  bottom: 0;
  height: px2rem(120);
  width: 100%;
  text-align: center;
  line-height: px2rem(120);
  font-size: px2rem(44);
  font-weight: 700;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  letter-spacing: 1px;
}
video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.bottom-btn {
  height: px2rem(178);
  width: 100%;
  background: #fb3458;
  .btn-row {
    width: 100%;
    height: px2rem(178);
    padding: 0 px2rem(32) 0 px2rem(40);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .text {
      flex: 1;
      font-size: px2rem(44);
      color: #fff;
      letter-spacing: 0.2px;
      font-weight: 700;
    }
    .btn {
      background: #fff;
      font-size: px2rem(36);
      color: #fb3458;
      padding: px2rem(20) px2rem(36);
      border-radius: px2rem(15);
      font-weight: 700;
    }
  }
}
.open-guide {
  position: fixed;
  top: 0;
  right: px2rem(51);
  width: px2rem(469);
  height: px2rem(323);
  box-sizing: border-box;
  padding: px2rem(132) px2rem(72) px2rem(51);
  color: #fff;
  font-size: px2rem(36);
  letter-spacing: 1px;
  background: url('../common/img/guide_bg.png') no-repeat left top;
  background-size: cover;
  z-index: 1004;
}
</style>
